import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import useSeo from '@/lib/useSeo';

export default function PageHero({ eyebrow, title, text, image, imageAlt = '', seoTitle }) {
  useSeo({ title: seoTitle || eyebrow, description: text, image });
  return (
    <section className="relative isolate overflow-hidden bg-ink-950">
      {image && (
        <img src={image} alt={imageAlt} className="absolute inset-0 -z-20 h-full w-full object-cover opacity-50" fetchpriority="high" />
      )}
      <div className="absolute inset-0 -z-10 bg-gradient-to-r from-ink-950 via-ink-950/85 to-primary-900/40" />
      <div className="absolute inset-x-0 bottom-0 -z-10 h-1 bg-flame-x" aria-hidden="true" />
      <div className="site-container py-16 sm:py-24">
        <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-sm text-ink-300">
          <Link to="/" className="hover:text-white">Home</Link>
          <ChevronRight className="h-4 w-4" aria-hidden="true" />
          <span className="text-accent-300">{eyebrow}</span>
        </nav>
        <h1 className="mt-5 max-w-3xl text-balance text-4xl leading-[1.05] text-white sm:text-6xl">{title}</h1>
        {text && <p className="mt-5 max-w-2xl text-pretty text-lg leading-relaxed text-ink-200">{text}</p>}
      </div>
    </section>
  );
}
